
export const VISIBILITY_TYPE = {
  IE: 'IE',
  E: 'E',
  I: 'I'
}

export const ROLE_TYPE = {
  FULL_TIME: 'F',
  PART_TIME: 'P',
  INTERNSHIP: 'I'
}

export const RESUME_TYPE = {
  BASIC: '0',
  MINI: '2',
  FULL: '1'
}

export const ASSESSMENT_TYPE = {
  NORMAL: '1',
  SIMPLE: '0'
}

export const JOB_STATUS_TYPE = {
  ACTIVE: '1',
  PENDING: '2',
  CLOSED: '0',
  CANCEL: '3'
}

export const CUSTOM_FIELD_TYPE = {
  SELECT: 'SELECT',
  SINGLE: 'SINGLE',
  TEXT: 'TEXT',
  TEXTAREA: 'TEXTAREA',
  DATE: 'DATE'
}

export const NEED_REDIRECT_TO_EXTERNAL_LINK = {
  SDfsf4gy: 'https://mycareer.hsbc.com/en_GB/external/PipelineDetail/Head-of-Mutual-Fund-Discretionary-ESG-HSBC-China/49668',
  fjpiKRYXY: 'https://mycareer.hsbc.com/en_GB/external/PipelineDetail/Vice-President-Transaction-Manager-Shanghai-HSBC-China/164781',
  fhQhRmyjc: 'https://mycareer.hsbc.com/en_GB/jobsforemployees/PipelineDetail/Assistant-Banking-Operations-Hangzhou-Operations-HSBC-China/160345',
  d0Y3GeIfI: 'https://mycareer.hsbc.com/en_GB/external/PipelineDetail/Senior-Investment-Product-Expert-Wealth-Personal-Banking-HSBC-China/35740',
  bO7QPkRpY: 'https://mycareer.hsbc.com/en_GB/external/PipelineDetail/151699',
  cR4v9RxFA: 'https://mycareer.hsbc.com/en_GB/external/PipelineDetail/Senior-Insurance-Specialist-Wealth-Personal-Banking-HSBC-China/50264'
}

export const JOB_STATUS = {
  CLOSED: 1,
  OPEN: 2,
  HOT: 3,
  ON_HOT: 4,
  CANCEL: 5
}

export const CHANNEL_ICON_MAPPING = {
  channel_ajinga: 'icona-CareershomeandWeChat',
  channel_51job: 'icona-51Job',
  channel_zhaopin: 'iconZhiLian',
  channel_liepin: 'iconLiepin',
  channel_58: 'icona-58TongCheng',
  channel_ganji: 'iconGanJiWang',
  channel_veryeast: 'iconZuiJiaDongFang',
  channel_shixiseng: 'iconShiXiSeng',
  channel_linkedin: 'iconLinkedin',
  channel_jobstreet: 'iconGongzuojie',
  channel_wotui: 'iconWotuiwang',
  channel_jobsdb: 'iconJobsDB',
  channel_zzjob88: 'iconZaozhiyingcai',
  channel_104: 'iconrenliyinhang',
  channel_indeed: 'icona-IndeedHK',
  channel_parttime: 'icona-parttimeHK',
  channel_boss: 'iconBoss1',
  channel_lagou: 'iconlagou1',
  channel_hrol: 'icona-zhenjianggrey',
  channel_91job: 'icona-jiangsugrey',
  channel_yimaitongdao: 'iconyimaitongdao',
  channel_liepin_agency: 'icona-liepinlietou1',
  channel_maimai: 'iconmaima',
  channel_gooood: 'icongooood'
}

export const CHANNEL_OPERATION_ADD = 'add'
export const CHANNEL_OPERATION_HIDE = 'delete'
export const CHANNEL_OPERATION_UPDATE = 'update'
export const CHANNEL_OPERATION_CANCEL = 'cancel'
export const CHANNEL_OPERATION_PUBLISH = 'published'
export const CHANNEL_OPERATION_VIEW = 'view'
export const CHANNEL_OPERATION_MANUAL_ADD = 'manualAdd'
export const DEFAULT_CHANNEL_ID = 1

export const CHANNEL_ID = {
  JOB51: 2,
  ZHI_LIAN: 3,
  LIE_PIN: 4,
  SHI_XI_SENG: 8,
  BOSS: 80,
  LIE_TOU: 84
}

export const CHANNEL_URL_MAP = {
  [CHANNEL_ID.JOB51]: {
    HOST: ['https://ehire.51job.com'],
    LOGIN_URL: 'https://ehire.51job.com/Revision/login?auto_login=1&returl=',
    PUBLISH_URL: 'https://ehire.51job.com/Revision/job?mark=new'
  },
  [CHANNEL_ID.ZHI_LIAN]: {
    HOST: ['https://rd6.zhaopin.com', 'https://passport.zhaopin.com'],
    LOGIN_URL: 'https://passport.zhaopin.com/org/login?auto_login=1&bkurl=',
    PUBLISH_URL: 'https://rd6.zhaopin.com/job/publish?from=jobmanage_jobpublish'
  },
  [CHANNEL_ID.LIE_PIN]: {
    HOST: ['https://lpt.liepin.com'],
    LOGIN_URL: 'https://lpt.liepin.com/login?auto_login=1&backurl=',
    PUBLISH_URL: 'https://lpt.liepin.com/job/publish?ejobActionType=publish'
  },
  [CHANNEL_ID.SHI_XI_SENG]: {
    HOST: ['https://hr.shixiseng.com'],
    LOGIN_URL: 'https://hr.shixiseng.com/login',
    LOGIN_REDIRECT_STORAGE_KEY: 'jumpoutRouter',
    PUBLISH_URL_BY_ROLE_TYPE: {
      [ROLE_TYPE.INTERNSHIP]: 'https://hr.shixiseng.com/job-management/internship/publish-job',
      DEFAULT: 'https://hr.shixiseng.com/job-management/campus-recruitment/job-add-or-edit'
    }
  },
  // [CHANNEL_ID.BOSS]: {
  // HOST: ['https://www.zhipin.com'],
  // LOGIN_URL: 'https://www.zhipin.com/web/user/?auto_login=1&intent=1&backurl=',
  // PUBLISH_URL: 'https://www.51job.com/pub'
  // },
  [CHANNEL_ID.LIE_TOU]: {
    HOST: ['https://h.liepin.com'],
    LOGIN_URL: 'https://h.liepin.com/account/login?auto_login=1&backurl=',
    PUBLISH_URL: 'https://h.liepin.com/job/showaddpage/'
  }
}

export const getChannelPublishUrl = (channelId, jobRoleType) => {
  const channelUrl = CHANNEL_URL_MAP[channelId]
  if (!channelUrl.PUBLISH_URL_BY_ROLE_TYPE) {
    return channelUrl.PUBLISH_URL
  }
  return channelUrl.PUBLISH_URL_BY_ROLE_TYPE[jobRoleType] || channelUrl.PUBLISH_URL_BY_ROLE_TYPE.DEFAULT
}

export const JOB_EDITOR_STEP_TYPE = {
  BASE_INFO: 'BASE_INFO',
  ADDITIONAL_INFO: 'ADDITIONAL_INFO',
  DESCRIPTION_INFO: 'DESCRIPTION_INFO',
  APPLICATION_CONFIG: 'APPLICATION_CONFIG',
  OPEN_QUESTION: 'OPEN_QUESTION',
  POST_CHANNEL: 'POST_CHANNEL',
  PERSONALITY_CALIBRATION: 'PERSONALITY_CALIBRATION',
  STATUS_HISTORY: 'STATUS_HISTORY',
  AI_COMPARISON_CRITERION: 'AI_COMPARISON_CRITERION',
  AI_INTERVIEW_ROOM: 'AI_INTERVIEW_ROOM',
  JOB_FIT_CONDITION: 'JOB_FIT_CONDITION'
}
